import React from "react";
import PropTypes from "prop-types";
import chroma from "chroma-js";

import { colors } from "../../../../theme";
import CovidLethalityMap from "./CovidLethalityMap";

function CovidLethalityMapVariation({ version, variationZoomState }) {
  const scaleColor = chroma
    .scale([
      chroma(colors.blue).brighten(0.25),
      chroma(colors.red).brighten(2),
      chroma(colors.red).darken(1.5),
    ])
    .classes(6);

  function getLocationColor(data) {
    if (data === null) {
      return chroma(colors.borderColor).brighten(0.3);
    }

    if (data < 0) {
      return scaleColor(0);
    } else if (data < 100) {
      return scaleColor(1 / 6);
    } else if (data < 200) {
      return scaleColor(2 / 6);
    } else if (data < 300) {
      return scaleColor(3 / 6);
    } else if (data <= 400) {
      return scaleColor(4 / 6);
    } else {
      return scaleColor(5 / 6);
    }
  }

  return (
    <CovidLethalityMap
      version={version}
      type="variation_2019_2020"
      typeLabel="Surmortalité"
      legend={{
        title: "Surmortalité en mars (2020 - 2019)",
        categories: [
          "Moins de 0",
          "Entre 0 et 100",
          "Entre 100 et 200",
          "Entre 200 et 300",
          "Entre 300 et 400",
          "Plus de 400",
        ],
        note:
          "Variation du nombre de décès recensés par l'Insee entre 2019 et 2020 sur la période du 1er au 30 mars.",
      }}
      formatTooltipValue={(val) => (val ? Math.round(val / 10) * 10 : val)}
      getLocationColor={getLocationColor}
      scaleColor={scaleColor}
      {...variationZoomState}
    />
  );
}

CovidLethalityMapVariation.propTypes = {
  version: PropTypes.oneOf(["v1", "v2"]).isRequired,
  variationZoomState: PropTypes.object.isRequired,
};

export default CovidLethalityMapVariation;
